import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets/components';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-native-builds-features-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './native-builds-features-section.component.html',
  styleUrl: './native-builds-features-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NativeBuildsFeaturesSectionComponent {}
